/* ew-chrome-v2.js — header/footer v2 behaviour
   - mobile drawer (open/close, ESC, overlay, scroll lock, focus return)
   - header shadow on scroll
   Namespaced on [data-c2-*] hooks so it never double-binds with ew-cart.js
   or the PDP v2 script. */
(function () {
  'use strict';

  function initDrawer() {
    var drawer = document.querySelector('[data-c2-drawer]');
    if (!drawer) return;

    var openBtns = [].slice.call(document.querySelectorAll('[data-c2-open]'));
    var closeBtns = [].slice.call(drawer.querySelectorAll('[data-c2-close]'));
    var lastFocus = null;

    function open() {
      lastFocus = document.activeElement;
      drawer.classList.add('c2-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
      openBtns.forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
      var first = drawer.querySelector('a, button');
      if (first) first.focus();
    }

    function close() {
      drawer.classList.remove('c2-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
      openBtns.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    openBtns.forEach(function (b) { b.addEventListener('click', open); });
    closeBtns.forEach(function (b) { b.addEventListener('click', close); });

    document.addEventListener('keydown', function (e) {
      if ((e.key === 'Escape' || e.keyCode === 27) && drawer.classList.contains('c2-open')) close();
    });

    // close after navigating to an in-page anchor
    drawer.addEventListener('click', function (e) {
      var a = e.target.closest ? e.target.closest('a') : null;
      if (a && a.getAttribute('href') && a.getAttribute('href').charAt(0) === '#') close();
    });
  }

  function initScrollShadow() {
    var header = document.querySelector('[data-c2-header]');
    if (!header) return;
    var ticking = false;
    function paint() {
      header.classList.toggle('c2-scrolled', window.pageYOffset > 4);
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; window.requestAnimationFrame(paint); }
    }, { passive: true });
    paint();
  }

  function init() { initDrawer(); initScrollShadow(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
